var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.05
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur)",
    id: "day"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,32)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am-weather-sun am-weather-sun-shiny am-weather-easing-ease-in-out"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,9)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 3
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "orange",
    r: 5,
    stroke: "orange",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/day.212e04206236caeb33f88e1c9dc942ad.svg";
export { ForwardRef as ReactComponent };